import { AttachmentModel } from '../../../../app/content/recourse-booking/model/attachment.model';
import { BookingPartialPaymentModel } from '../../../../app/content/recourse-booking/model/booking-partial-payment-model';
import { SupplierModel } from '../../../services/supplier-service/model/supplier.model';

export class RecourseBookingModel {
  public pkBookingId: number;
  public bookingType: string;
  public bookingStateId: number;
  public bookingDate: string;
  public originatorId: string;
  public invoiceReasonText: string;
  public createDate: Date;
  public manualBooking: string;
  public recourseTypeId: number;
  public useridCreate: string;
  public referencedBookingId: number;
  public totalReferencedAmount: number;
  public recourseId: string;
  public bookingCurrency: string;
  public currencyRateDate: Date;
  public bookingStateReason: string;
  public creator: string;
  public attachments: AttachmentModel[];
  public supplierData: SupplierModel;
  public partialPaymentItems: BookingPartialPaymentModel[];
  public revenueOrderNumber: string;
  public signatureValid: boolean;
  public signatureValidAttachments: boolean;
  public bookingJustificationComment: string;
}
